export const AppStatus = {
  Incomplete: 'Incomplete',
  Draft: 'Draft',
  Withdrawn: 'Withdrawn',
  Hired: 'Hired',
  InProcess: 'In Process',
  Closed: 'Closed'
}

export const isAppliedJobs = (appStatus) => {
  if ([AppStatus.Withdrawn, AppStatus.Hired, AppStatus.InProcess, AppStatus.Closed].includes(appStatus)) return true
  else return false
}

export const isSavedJobs = (appStatus) => {
  if ([AppStatus.Incomplete, AppStatus.Draft].includes(appStatus)) return true
  else return false
}
